import { Component } from "./Component";

export class nav extends Component {

    private spy: IntersectionObserver | null = null;

    protected onMount(): void {

        // highlight the link for the section currently in the middle of the viewport
        const links = [...this.querySelectorAll<HTMLAnchorElement>('.nav-links a')];

        this.spy = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (!entry.isIntersecting) continue;
                const id = `#${entry.target.id}`;
                links.forEach((l) => l.classList.toggle('is-active', l.getAttribute('href') === id));
            }
        }, { rootMargin: '-45% 0px -45% 0px' });

        links.forEach((l) => {
            const section = document.querySelector(l.getAttribute('href') ?? '');
            if (section) this.spy?.observe(section);
        });

        window.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', this.onScroll);
        this.onScroll();
    }

    protected onDestroy(): void {
        this.spy?.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
    }

    private onScroll = () => {
        const pill = this.querySelector('.nav-pill');
        if (!pill) return;

        const rect = pill.getBoundingClientRect();
        const pillCenterY = rect.top + rect.height / 2;

        const darkSections = ['#services', '#process', '#contact'];
        let isOverDark = false;

        for (const id of darkSections) {
            const section = document.querySelector(id);
            if (!section) continue;

            const sectionRect = section.getBoundingClientRect();
            let top = sectionRect.top;
            const bottom = sectionRect.bottom;

            // Adjust top boundary if there is a wave-divider inside the services section
            if (id === '#services') {
                const wave = section.querySelector('wave-divider');
                if (wave) {
                    const waveRect = wave.getBoundingClientRect();
                    top = waveRect.top;
                }
            }

            if (pillCenterY >= top && pillCenterY <= bottom) {
                isOverDark = true;
                break;
            }
        }

        pill.classList.toggle('is-over-dark', isOverDark);
    };

}

// Register the component with an HTML tag
customElements.define('silly-little-nav', nav);
